/* eslint-disable camelcase */
/// HEY YOU! LISTEN! These must be in an order so iterating them with a `startsWith` type pattern will return longer paths first!
/// NOTE handle `:id` params etc. in App.tsx, DO NOT ADD HERE
enum Route {
  agencyDashboardHome = '/dashboard/agency/home',
  agencyDashboardReports = '/dashboard/agency/reports',
  agencyDashboardClient = '/dashboard/agency/client',
  agencyDashboardClients = '/dashboard/agency/clients',
  agencyDashboardClientsPlan = '/dashboard/agency/clients/plan',
  agencyDashboardProducers = '/dashboard/agency/producers',
  agencyDashboardEmployees = '/dashboard/agency/employees',
  agencyDashboardAgencies = '/dashboard/agency/agencies',
  agencyDashboardAccount = '/dashboard/agency/account',

  dashboardEmployerEmployees = '/dashboard/employer/employees',
  dashboardEmployerProfile = '/dashboard/employer/profile',
  dashboardEmployerBilling = '/dashboard/employer/billing',
  dashboardEmployer = '/dashboard/employer',

  dashboardEmployee = '/dashboard/employee',
  dashboardEmployeeProfile = '/dashboard/employee/profile',

  agencyDashboard = '/dashboard/agency',

  dashboard = '/dashboard',

  agencyShop_GetStarted = '/shop/agency/getstarted',
  agencyShop_SignUp = '/shop/agency/signup',
  // agencyShop_TutorialVideo = '/shop/agency/tutorial',
  agencyShop_Pricing = '/shop/agency/pricing',
  agencyShop_Payment = '/shop/agency/payment',
  // agencyShop_Walkthrough = '/shop/agency/walkthrough',
  agencyShop_LicensesandAppointments = '/shop/agency/licenses',
  agencyShop_AgencyShop = '/shop/agency/shop-setup',
  agencyShop_Producers = '/shop/agency/producers',
  agencyShop = '/shop/agency',
  stargate = '/shop',

  erStargate_GroupType = '/shop/employer/group-type',
  erStargate_Checklist = '/shop/employer/checklist',
  erStargate_GetStarted = '/shop/employer/get-started',
  erStargate_Census = '/shop/employer/census',
  erStargate_CensusWaive = '/shop/employer/census/waive',
  erStargate_ScheduleACall = '/shop/employer/schedule',
  erStargate_Plans = '/shop/employer/plans',
  erStargate_SidecarInfo = '/shop/employer/plans/sidecar-health',
  erStargate_AncillaryPlans = '/shop/employer/plans/ancillary',
  erStargate_Proposal = '/shop/employer/plans/proposal',
  // erStargate_Supplemental = '/shop/employer/plans/supplemental',
  erStargate_IMQs = '/shop/employer/imqs',
  erStargate_EHQ = '/shop/employer/ehq',
  erStargate_CarvedContributions = '/shop/employer/plans/contribution/carved',
  erStargate_Contribution = '/shop/employer/plans/contribution',
  erStargate_Application = '/shop/employer/plans/application',
  erStargate_Review = '/shop/employer/plans/review',
  erStargate_Finalize = '/shop/employer/confirm',
  erStargateRefresh = '/shop/employer/refresh',

  eeStargate_info = '/shop/employee/census',
  eeStargate_work = '/shop/employee/work',
  eeStargate_family = '/shop/employee/census/family',
  eeStargate_redflags = '/shop/employee/medical',
  eeStargate_have_plan = '/shop/employee/plans/already-covered',
  eeStargate_select = '/shop/employee/plans/health',
  eeStargate_ancillary = '/shop/employee/plans/ancillary',
  eeStargate_supplemental = '/shop/employee/plans/supplemental',
  eeStargate_enroll = '/shop/employee/plans/enroll',
  eeStargate_underwriting = '/shop/employee/plans/underwriting',
  eeStargate_application = '/shop/employee/plans/application',
  eeStargate_pay = '/shop/employee/checkout',
  eeStargate_confirm = '/shop/employee/confirm',

  signUp = '/account/sign-up',
  signIn = '/account/sign-in',
  signOut = '/account/sign-out',
  forgotPassword = '/account/recover',
  resetPassword = '/account/reset-password',

  brokerLanding = '/landing',

  reset = '/reset',
  landing = '/' // MUST BE LAST!
}
/// HEY YOU! I HOPE YOU LISTENED!
function getTitle(route: Route): string {
  const titles = {
    [Route.agencyDashboardProducers]: 'Agency',
    [Route.agencyShop_Producers]: 'Agency',
    [Route.agencyDashboardClient]: 'Clients',
    [Route.agencyDashboardClients]: '',
    [Route.agencyDashboardClientsPlan]: '',
    [Route.agencyDashboardReports]: 'Reports',
    [Route.agencyDashboardAgencies]: '',
    [Route.dashboardEmployerEmployees]: 'Employees',
    [Route.agencyDashboardEmployees]: 'Employees',
    [Route.dashboardEmployerProfile]: 'Company Profile',
    [Route.dashboardEmployerBilling]: 'Billing',
    [Route.agencyShop_Payment]: 'Billing',
    [Route.agencyDashboardAccount]: 'Your Account',
    [Route.dashboardEmployer]: 'Home',
    [Route.dashboardEmployeeProfile]: 'Your Profile',
    [Route.dashboard]: 'Home',
    [Route.agencyDashboard]: 'Home',
    [Route.agencyDashboardHome]: 'Home',
    [Route.dashboardEmployee]: 'Dashboard',
    [Route.stargate]: 'Shop',
    [Route.agencyShop]: 'Shop',

    // [Route.agencyShop_TutorialVideo]: 'Tutorial',
    [Route.agencyShop_Pricing]: 'Pricing',
    // [Route.agencyShop_Walkthrough]: 'Walkthrough',
    [Route.agencyShop_LicensesandAppointments]: 'Licenses and Appointments',
    [Route.agencyShop_AgencyShop]: 'Landing Page Setup',
    [Route.erStargate_GroupType]: 'Group Type',
    [Route.erStargate_Checklist]: 'Checklist',
    [Route.agencyShop_GetStarted]: 'Get Started',
    [Route.erStargate_GetStarted]: 'Get Started',
    [Route.erStargate_Census]: 'Census',
    [Route.erStargate_CensusWaive]: 'Census·Waive',
    [Route.erStargate_ScheduleACall]: 'Schedule A Call',
    [Route.erStargate_Contribution]: 'Plans·Contributions',
    [Route.erStargate_CarvedContributions]: 'Plans·Contributions·Carved',
    [Route.erStargate_Plans]: 'Plans',
    [Route.erStargate_Application]: 'Sidecar Health Info',
    [Route.erStargate_AncillaryPlans]: 'Plans·Ancillary',
    [Route.erStargate_Proposal]: 'Proposal',
    // [Route.erStargate_Supplemental]: 'Supplemental Plans',
    [Route.erStargate_IMQs]: 'Medical Questionnaires',
    [Route.erStargate_EHQ]: 'Forms',
    [Route.erStargate_SidecarInfo]: 'Carrier Application',
    [Route.erStargate_Review]: 'Review',
    [Route.erStargate_Finalize]: 'Finalize',
    [Route.erStargateRefresh]: 'Refresh',

    [Route.eeStargate_info]: 'TODO',
    [Route.eeStargate_work]: 'TODO',
    [Route.eeStargate_family]: 'TODO',
    [Route.eeStargate_redflags]: 'TODO',
    [Route.eeStargate_have_plan]: 'TODO',
    [Route.eeStargate_select]: 'TODO',
    [Route.eeStargate_ancillary]: 'TODO',
    [Route.eeStargate_supplemental]: 'TODO',
    [Route.eeStargate_underwriting]: 'TODO',
    [Route.eeStargate_enroll]: 'TODO',
    [Route.eeStargate_pay]: 'TODO',
    [Route.eeStargate_confirm]: 'TODO',
    [Route.eeStargate_application]: 'Application',
    [Route.brokerLanding]: 'Broker Landing',
    [Route.signIn]: 'Sign‑In',
    [Route.signOut]: 'Sign‑Out',
    [Route.reset]: 'Reset',
    [Route.forgotPassword]: 'Recover Account',
    [Route.resetPassword]: 'Reset Password',
    [Route.landing]: 'Landing Page',
    [Route.signUp]: 'Sign Up',
    [Route.agencyShop_SignUp]: 'Sign Up'
  }
  return titles[route]
}

export { Route, getTitle }
